let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5EV3L")).then(() => parcelRequire('658iW'));